existingRef